import { useQuery } from "@tanstack/react-query";
import { getAtkomstCountries } from "@coworker/app/src/hooks/API/core.service";
import { INTERVAL } from "@coworker/app/src/constants/clientTime";
import { Country } from "@coworker/app/src/core/hooks/useCountries";

/**
 * Fetches the full unfiltered list of countries from the Atkomst admin
 * endpoint. Unlike `useCountries`, the result is not filtered by the Cloud Run
 * region serving the request, so all countries are returned regardless of
 * deployment region. Gated by Platform Owner permission on the backend.
 */
export function useAtkomstCountries(enabled = true) {
  return useQuery<Country[]>({
    queryKey: ["atkomstCountries"],
    queryFn: async () => (await getAtkomstCountries()) ?? [],
    enabled,
    retry: false,
    staleTime: 2 * INTERVAL.HOUR,
    refetchOnWindowFocus: false,
  });
}
